import { partnerRequest } from '../services/request.service'

const API_URL = window.env ? window.env.API_SERVER : '';
const NO_CONTENT = 2;
const REQUEST_FAILURE = 1;
const REQUEST_SUCCESS = 0;

const clearPartnerCacheSuccess = 'PARTNER_CLEAR_SUCCESS';
const clearPartnerCacheFailure = 'PARTNER_CLEAR_FAILURE';

const clearPublicCacheSuccess = 'PUBLIC_CLEAR_SUCCESS';
const clearPublicCacheFailure = 'PUBLIC_CLEAR_FAILURE';

const clearAuthCacheSuccess = 'AUTH_CLEAR_SUCCESS';
const clearAuthCacheFailure = 'AUTH_CLEAR_FAILURE';

const initialState = {
    clearPublicCacheError: '',
    clearPartnerCacheError: '',
    clearAuthCacheError: ''
}

export const cacheActionCreators = {

    receiveClearPartnerCache: () => ({
        type: clearPartnerCacheSuccess,
    }),

    clearPartnerCacheError: (message) => ({
        type: clearPartnerCacheFailure,
        clearPartnerCacheError: message
    }),

    clearPartnerCache: (service) => {
        return dispatch => {
            let headers = {
                'content-type': "application/json; charset=utf-8"
            }
            return partnerRequest((API_URL || process.env.REACT_APP_STATS_API_URL) + "/" + service + '/api/ClearPartnerCache', 'GET', headers, '', '')
                .then(result => {
                    if (result[0] === REQUEST_FAILURE) {
                        dispatch(cacheActionCreators.clearPartnerCacheError(result[1]));
                        return Promise.reject(result[1]);
                    } else if (result[0] === REQUEST_SUCCESS) {
                        dispatch(cacheActionCreators.receiveClearPartnerCache(result[1]));
                    } else if (result[0] === NO_CONTENT) {
                        dispatch(cacheActionCreators.receiveClearPartnerCache([]));
                    } else if (result.name === 'AbortError') {
                        return Promise.reject("Aborted");
                    }
                }).catch(err => Promise.reject(err));
        }
    },

    receiveClearPublicCache: () => ({
        type: clearPublicCacheSuccess,
    }),

    clearPublicCacheError: (message) => ({
        type: clearPublicCacheFailure,
        clearPublicCacheError: message
    }),

    clearPublicCache: (service) => {
        return dispatch => {
            let headers = {
                'content-type': "application/json; charset=utf-8"
            }
            return partnerRequest((API_URL || process.env.REACT_APP_STATS_API_URL) + "/" + service + '/api/ClearPublicCache', 'GET', headers, '', '')
                .then(result => {
                    if (result[0] === REQUEST_FAILURE) {
                        dispatch(cacheActionCreators.clearPublicCacheError(result[1]));
                        return Promise.reject(result[1]);
                    } else if (result[0] === REQUEST_SUCCESS) {
                        dispatch(cacheActionCreators.receiveClearPublicCache(result[1]));
                    } else if (result[0] === NO_CONTENT) {
                        dispatch(cacheActionCreators.receiveClearPublicCache([]));
                    } else if (result.name === 'AbortError') {
                        return Promise.reject("Aborted");
                    }
                }).catch(err => Promise.reject(err));
        }
    },

    receiveClearAuthCache: () => ({
        type: clearAuthCacheSuccess,
    }),

    clearAuthCacheError: (message) => ({
        type: clearAuthCacheFailure,
        clearAuthCacheError: message
    }),

    clearAuthCache: () => {
        return dispatch => {
            let headers = {
                'content-type': "application/json; charset=utf-8"
            }
            return partnerRequest((API_URL || process.env.REACT_APP_STATS_API_URL) + '/Authentication/api/ClearCacheByEmailAsync', 'POST', headers, '', '')
                .then(result => {
                    if (result[0] === REQUEST_FAILURE) {
                        dispatch(cacheActionCreators.clearAuthCacheError(result[1]));
                        return Promise.reject(result[1]);
                    } else if (result[0] === REQUEST_SUCCESS) {
                        dispatch(cacheActionCreators.receiveClearAuthCache(result[1]));
                    } else if (result[0] === NO_CONTENT) {
                        dispatch(cacheActionCreators.receiveClearAuthCache([]));
                    } else if (result.name === 'AbortError') {
                        return Promise.reject("Aborted");
                    }
                }).catch(err => Promise.reject(err));
        }
    }
}


export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case clearPartnerCacheSuccess:
            return Object.assign({}, state, {
                clearPartnerCacheError: ''
            })
        case clearPartnerCacheFailure:
            return Object.assign({}, state, {
                clearPublicCacheError: action.clearPublicCacheError
            })
        case clearPublicCacheSuccess:
            return Object.assign({}, state, {
                clearPublicCacheError: ''
            })
        case clearPublicCacheFailure:
            return Object.assign({}, state, {
                clearPublicCacheError: action.clearPublicCacheError
            })
        case clearAuthCacheSuccess:
            return Object.assign({}, state, {
                clearAuthCacheError: ''
            })
        case clearAuthCacheFailure:
            return Object.assign({}, state, {
                clearAuthCacheError: action.clearAuthCacheError
            })
        default:
            return state
    }
};